<template>
<m-pageframe
    :title="title"
>
<v-container v-if="template != null">

     <v-text-field
        label="Organization"
        :value="organization_label"
        readonly
        disabled
    />

    <v-text-field
        label="Message Type"
        :value="template.template_context"
        readonly
        disabled
    />

    <v-text-field
        label="Template Label"
        :value="template.template_label"
        readonly
        disabled
    />

    <v-text-field
        label="Send From"
        :value="prettyPrintSendFrom()"
        readonly
        disabled
    />

    <m-autocomplete-phone-number
        label="Send To"
        v-model="endpoint"
    />

    <m-populate-message-patterns
        :context="template.template_context"
        :patterns="template.message_patterns"
        ref="populate-ctrl"
    />

    <div
        style="text-align: right"
    >
        <v-btn
            v-on:click="onClickTemplateSettings"
            style="margin-right: 15px"
        >
            Template Settings...
        </v-btn>

        <v-btn
            color="primary"
            v-on:click="onClickTrigger"
            :disabled="!is_valid"
        >
            Trigger Message
        </v-btn>
    </div>
  

</v-container>
</m-pageframe>
</template>

<script>
const E164 = require('@/js/E164.js');

export default {
    data() {
        return {
            organization_label: null,
            template: null,
            endpoint: null,
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            let params = {
                'organization_id' : this.$route.params.organization_id,
                'template_subject_id' : this.$route.params.template_subject_id,
                'template_context' : this.$route.params.template_context,
            };
            
            this.$rc.getAutoMessageTemplateProfile(
                params,
            
                (data) => {

                    this.organization_label = data.organization_label;
                    this.template = data.template;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to get template information');
                },
            );
        },

        prettyPrintSendFrom()
        {
            return E164.prettyPrintUsPhoneNumber(this.template.send_from);
        },

        onClickTemplateSettings()
        {
            this.$router.push({
                'name': 'auto-messages-template-settings',
                'params' : {
                    'organization_id' : this.$route.params.organization_id,
                    'template_context' : this.$route.params.template_context,
                    'template_subject_id': this.$route.params.template_subject_id,
                }
            }).catch(e=>{}); // swallow any exception    
        },

        onClickTrigger()
        {
            let params = {
                'organization_id': this.$route.params.organization_id,
                'template_context': this.$route.params.template_context,
                'template_subject_id': this.$route.params.template_subject_id,
                'send_to': this.endpoint.value,
                'message_params': this.$refs['populate-ctrl'].getParams(),
            };

            this.$rc.showSpinner();
            
            this.$rc.triggerAutoMessage(

                params,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$rc.snackbar('Message triggered');

                    this.$router.push({
                        'name': 'auto-messages-search-messages',
                        'params' : {
                            'organization_id' : this.$route.params.organization_id,
                            'template_context' : this.$route.params.template_context,
                            'template_subject_id': this.$route.params.template_subject_id,
                        }
                    }).catch(e=>{}); // swallow any exception    
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to trigger message');
                },
            );
        },
    },

    computed: {
        title() {
            let template = this.template;
            if ( template == null ) return 'Trigger Automated Message';

            return 'Trigger '+template.template_label+' Message';
        },

        is_valid() {
            if ( this.endpoint == null ) return false;
            if ( !this.$refs['populate-ctrl'].isValid() ) return false;

            return true;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>